import locationRemark from '@/api/sale/location-tracking-remark'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, data) {
    return locationRemark.get(data).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return locationRemark.store(data)
  },
  exportExcel(context, data) {
    return locationRemark.exportExcel(data)
  },
  getUserGroup(context, Options = {}) {
    return locationRemark.userGroup({ params: Options })
  }
}
